module.exports = __webpack_public_path__ + "static/assets/73c46ab5b6dc228e369b6bb688031916.svg";